<form
  [formGroup]="form"
  NfFormValidation
  (validSubmit)="onSubmit()"
  data-cy="form"
>
  <div class="modal-header" hsDraggable="modal-dialog">
    <h4 class="modal-title">Edit Transaction Note</h4>
    <button
      nf-icon-button="cancel"
      icon="close"
      class="btn-bare"
      ngbTooltip="Close"
      (click)="onCancel()"
    >
      Close
    </button>
  </div>
  <div class="modal-body" hsDraggable="modal-dialog">
    <nf-form-control
      class="notes-control"
      label="Note"
      [customErrorMessages]="validationMessages.notesValidationMessages"
    >
      <textarea
        ngbAutofocus
        class="form-control"
        id="noteFormControl"
        formControlName="noteTextArea"
        data-cy="noteTextArea"
      ></textarea>
    </nf-form-control>
  </div>
  <div class="modal-footer" hsDraggable="modal-dialog">
    <button nf-button (click)="onCancel()">Cancel</button>
    <button nf-button="save" [disabled]="form.invalid" (click)="onSubmit()">
      Save
    </button>
  </div>
</form>
